/* eslint-disable max-len */
import {
  useCallback, useEffect, useRef, useState,
} from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { message, Form } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import devicesAction from '@state/device/actions';
import devicesApi from '@api/devicesApi';

function useDispositivos() {

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const dataInit = useSelector(({ device: a }) => a.createNewDevice);
  const idToEdit = useSelector(({ device: a }) => a.deviceIdToEdit);
  const saveState = useSelector(({ inverters }) => inverters.saveState);
  // const [initialLoadComplete, setInitialLoadComplete] = useState(false);

  const [form] = Form.useForm();
  const [dataGateway, setDataGateway] = useState([]);
  const [businessType, setBusinessType] = useState([]);
  const [deviceType, setDeviceType] = useState([]);
  const [dataForm, setDataForm] = useState(dataInit);
  const [loadingSave, setLoadingSave] = useState(false);

  const currentUserRol = useSelector(({ user }) => user.role);

  const abortC = new AbortController();
  const { signal } = abortC;
  const backup = useRef(saveState.inverter);

  const skip = 0;
  const limit = 1000;

  const defaultData = {
    name: '',
    client: '',
    business_type_id: '',
    device_type_id: [],
    slvId: '',
    gateway_id: '',
  };

  const onFinish = useCallback((values) => { // submit: create device or edit device

    if (!idToEdit) { //  create device

      const data = dataInit;
      data.slvId = Number(data.slvId);

      setLoadingSave(true);

      devicesApi.createDevice({ signal, body: data })
        .then((response) => {

          message.success(t('views.create_devices.form.create_success'));
          setDataForm(defaultData);
          dispatch(devicesAction.setCreateEditDevice(defaultData));
          dispatch(devicesAction.setDeviceIdEdit(null));
          setLoadingSave(false);

          // history.push('/dispositivos/administrar');
          history.goBack();

        })
        .catch((resError) => {

          // eslint-disable-next-line
          console.log(resError);
          setLoadingSave(false);
          message.error(resError?.data?.detail || t('views.create_devices.form.create_error'));

        });

    } else { // Edit Device

      const data = dataInit;
      data.slvId = Number(data.slvId);

      setLoadingSave(true);

      devicesApi.editDevice({ signal, body: data, id: idToEdit })
        .then((response) => {

          message.info(t('views.create_devices.form.edit_success'));
          setDataForm(defaultData);
          dispatch(devicesAction.setCreateEditDevice(defaultData));
          dispatch(devicesAction.setDeviceIdEdit(null));
          setLoadingSave(false);
          // history.push('/dispositivos/administrar');
          history.goBack();

        })
        .catch((resError) => {

          setLoadingSave(false);
          message.error(resError?.data?.detail || t('views.create_devices.form.edit_failed'));
          // eslint-disable-next-line
          console.log(resError);

        });

    }

    // eslint-disable-next-line
  }, [dispatch, signal]);

  const onFinishFailed = (errorInfo) => { // data imcomplete

    // eslint-disable-next-line
    console.log(errorInfo.errorFields[0].errors[0]);
    message.error(errorInfo.errorFields[0].errors[0]);

  };

  const formOnValuesChange = useCallback( // handle data
    (value) => {

      const key = Object.keys(value);
      const data = Object.values(value);

      setDataForm({ ...dataForm, [key[0]]: data[0] });
      dispatch(devicesAction.setCreateEditDevice({ ...dataForm, [key[0]]: data[0] }));

    },
    // eslint-disable-next-line
    [dataForm, dispatch]
  );

  const getBusinessType = useCallback( // get the Api business Type
    // change to portal data
    () => {

      devicesApi.getAllBusinessType({ signal, skip, limit })
        .then((response) => {

          if (response.length > 0) {

            const newBusinessType = response.map((item) => ({
              value: item.id,
              label: item.name,
            }));

            const sortBusinessType = newBusinessType.sort((a, b) => {

              if (a.label < b.label) {

                return -1;

              }
              if (a.label > b.label) {

                return 1;

              }
              return 0;

            });

            setBusinessType(sortBusinessType);

          }

        })
        .catch((error) => {

          // eslint-disable-next-line
          console.log('error: ', error);

        });

    },
    // eslint-disable-next-line
    [businessType, dispatch]
  );

  const getDeviceType = useCallback( // get the Api Device Type
    // change to portal data
    (businessTypeIds) => {

      let businessTypeIdsQuery = '';

      if (businessTypeIds !== '' || businessTypeIds !== undefined) {

            businessTypeIdsQuery += `business_type_id=${businessTypeIds}`;

}

      devicesApi.getAllDeviceTypeUnifiedByBusiness(signal, skip, limit, businessTypeIdsQuery)
        .then((response) => {

          if (response.length > 0) {

            const newDevicesType = response.map((item) => ({
              value: item.id,
              label: item.name,
            }));

            const sortDevicesType = newDevicesType.sort((a, b) => {

              if (a.label < b.label) {

                return -1;

              }
              if (a.label > b.label) {

                return 1;

              }
              return 0;

            });

            setDeviceType(sortDevicesType);

          } else {

            setDeviceType([]);

}

        })
        .catch((error) => {

          // eslint-disable-next-line
          console.log('error: ', error);

        });

    },
    // eslint-disable-next-line
    [deviceType, dispatch]
  );

  const getGateway = useCallback( // get the Api Device Type
    // change to portal data
    (businessTypeIds) => {

      let businessTypeIdsQuery = '';

      if (businessTypeIds !== '' || businessTypeIds !== undefined) {

            businessTypeIdsQuery += `business_type_id=${businessTypeIds}`;

}

      devicesApi.getAllGatewayByBusiness(signal, skip, limit, businessTypeIdsQuery)
        .then((response) => {

          if (response.length > 0) {

            const newGateway = response.map((item) => ({
              value: item.id,
              label: item.name,
            }));

            const sortGateway = newGateway.sort((a, b) => {

              if (a.label < b.label) {

                return -1;

              }
              if (a.label > b.label) {

                return 1;

              }
              return 0;

            });

            setDataGateway(sortGateway);

          } else {

            setDataGateway([]);

}

        })
        .catch((error) => {

          // eslint-disable-next-line
          console.log('error: ', error);

        });

    },
    // eslint-disable-next-line
    [dataGateway, dispatch]
  );

  const cancelCreateEditDevice = useCallback(
    () => {

      // history.replace(pathBefore || '/dispositivos/administrar');
      history.goBack();

    },
    // eslint-disable-next-line
    [],

  );

  const handleDeviceHome = () => {

    if (businessType && businessType.id) {

      history.push(`/tablero-devices/${businessType.id}`);

    } else {

      cancelCreateEditDevice();

    }

  };

  const onData = (value) => { // data imcomplete

    // eslint-disable-next-line
    setDataForm({
      ...dataForm,
      business_type_id: value,
      device_type_id: [],
      gateway_id: '',
    });

     // Actualiza los valores de los campos del formulario
    form.setFieldsValue({
      ...dataForm,
      business_type_id: value,
      device_type_id: [],
      gateway_id: '',
    });

    getDeviceType(value);
    getGateway(value);

  };

  /* useEffect(() => {

    //if (!initialLoadComplete && dataForm.business_type_id !== '') {
      // eslint-disable-next-line
      setDataForm({
        ...dataForm,
        device_type_id: [],
      });

       // Actualiza los valores de los campos del formulario
      form.setFieldsValue({
        ...dataForm,
        device_type_id: [],
      });
    }

    if(dataForm.business_type_id !== '') {
      //setInitialLoadComplete(true);
    }
  }, [deviceType]);

  useEffect(() => {

    //if (!initialLoadComplete && dataForm.business_type_id !== '') {
      // eslint-disable-next-line
      setDataForm({
        ...dataForm,
        gateway_id: '',
      });

       // Actualiza los valores de los campos del formulario
      form.setFieldsValue({
        ...dataForm,
        gateway_id: '',
      });
    }

    if(dataForm.business_type_id !== '') {
      //setInitialLoadComplete(true);
    }

  }, [dataGateway]); */

  useEffect(() => { // mount component

    getBusinessType();
    getDeviceType(dataInit?.business_type_id);
    getGateway(dataInit?.business_type_id);

    if (!idToEdit && location.pathname === '/dispositivos/editar-dispositivo') {

      // If trying to edit without idToEdit, redirect to tipo-negocio
        history.push('/dispositivos/administrar');

} else if (!idToEdit && currentUserRol !== 'Superadmin' && currentUserRol !== 'Admin') {

          // If trying to create without idToEdit and not Superadmin or Admin, redirect to tipo-negocio
          history.push('/dispositivos/administrar');

}
    return function cleanUp() {

      if (!backup.current || idToEdit) {

        dispatch(devicesAction.setDeviceIdEdit(null));
        dispatch(devicesAction.setCreateEditDevice(defaultData));

      }

    };
    // eslint-disable-next-line
  }, []);

  return {
    onFinish,
    onFinishFailed,
    formOnValuesChange,
    dataForm,
    dataGateway,
    businessType,
    deviceType,
    loadingSave,
    idToEdit,
    cancelCreateEditDevice,
    handleDeviceHome,
    onData,
    form,
  };

}

export default useDispositivos;
